import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import "@harbor/elements/styles.css";
import "@harbor/elements/dist/harbor-elements/styles/themes/magnetic.css";
import "@harbor/elements/dist/harbor-elements/styles/themes/magnetic.dark.css";
import "@harbor/elements/dist/harbor-elements/styles/tokens/magnetic.css";
import "@harbor/elements/dist/harbor-elements/styles/tokens/magnetic.dark.css";
import './assets/main.css';
import './index.scss';
import './components/security-toolbox-ui/security-toolbox-ui.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './support/otel';
import { store, persistor } from './support/store';
import { QueryClientProvider } from '@tanstack/react-query'; //-tech-debt-react-query;
import { queryClient } from './support/queryClient';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { HbrSpinner } from '@harbor/elements-react-standalone';

// these imports are required for harbor to look nice
import "@harbor/elements/dist/harbor-elements/styles/themes/magnetic-classic.css";
import "@harbor/elements/dist/harbor-elements/styles/themes/magnetic-brand-alt.css";

const container = document.getElementById('root');

if (container) {
  const root = createRoot(container);

  root.render(
    //<React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          <PersistGate loading={<HbrSpinner />} persistor={persistor}>
            <BrowserRouter>
              <App />
              <div id="stb-app-modal" />
            </BrowserRouter>
          </PersistGate>
        </Provider>
      </QueryClientProvider>
    //</React.StrictMode>
  );
}

reportWebVitals();